/**
 * Italian translations for Stream Chat
 * Complete localization configuration for Stream Chat UI components
 */

export const italianTranslations = {
	// Message input and sending
	'Type your message': 'Scrivi il tuo messaggio...',
	'Send': 'Invia',
	'Send message': 'Invia messaggio',
	
	// Time and dates
	'Today': 'Oggi',
	'Yesterday': 'Ieri',
	'at': 'alle',
	'Today at {{ time }}': '{{ time }}',
	'Yesterday at {{ time }}': '{{ time }}',
	'just now': 'proprio ora',
	'{{ count }} minutes ago': '{{ count }} minuti fa',
	'{{ count }} hours ago': '{{ count }} ore fa',
	'{{ count }} days ago': '{{ count }} giorni fa',
	'{{ timestamp }}': '{{ timestamp }}',
	
	// Message states
	'Message deleted': 'Messaggio eliminato',
	'Only visible to you': 'Visibile solo a te',
	'Message failed to send': 'Invio del messaggio fallito',
	'Retry': 'Riprova',
	'Sending...': 'Invio in corso...',
	'Delivered': 'Consegnato',
	'Read': 'Letto',
	
	// Message actions
	'Edit Message': 'Modifica messaggio',
	'Delete Message': 'Elimina messaggio',
	'Reply': 'Rispondi',
	'Thread Reply': 'Rispondi nel thread',
	'Reactions': 'Reazioni',
	'Add a reaction': 'Aggiungi una reazione',
	'Copy Message': 'Copia messaggio',
	'Pin Message': 'Fissa messaggio',
	'Unpin Message': 'Rimuovi fissaggio',
	
	// Users and members
	'You': 'Tu',
	'and': 'e',
	'others': 'altri',
	'{{ user }}': '{{ user }}',
	'Channel Info': 'Info canale',
	'Members': 'Membri',
	'Add Members': 'Aggiungi membri',
	'Remove from channel': 'Rimuovi dal canale',
	'Mute user': 'Silenzia utente',
	'Unmute user': 'Riattiva utente',
	
	// Search and navigation
	'Search': 'Cerca',
	'No results found': 'Nessun risultato trovato',
	'Start typing to search for people': 'Inizia a digitare per cercare persone',
	'Jump to latest message': 'Vai all\'ultimo messaggio',
	
	// Loading states and errors
	'Loading...': 'Caricamento...',
	'Something went wrong...': 'Qualcosa è andato storto...',
	'Try again': 'Riprova',
	'Error loading messages': 'Errore nel caricamento dei messaggi',
	'Failed to load': 'Caricamento fallito',
	
	// Files and upload
	'File upload failed': 'Caricamento file fallito',
	'Maximum file size is {{ limit }}': 'La dimensione massima del file è {{ limit }}',
	'Upload a file': 'Carica un file',
	'Drop your files here': 'Trascina i tuoi file qui',
	'Attach files': 'Allega file',
	'Download': 'Scarica',
	
	// Empty conversations
	'Empty conversation': 'Conversazione vuota',
	'How about sending your first message?': 'Che ne dici di inviare il tuo primo messaggio?',
	'Nothing here yet...': 'Ancora niente qui...',
	'Start a conversation': 'Inizia una conversazione',
	'No channels': 'Nessun canale',
	
	// New messages and notifications
	'New Messages': 'Nuovi messaggi',
	'{{ count }} new': '{{ count }} nuovi',
	'{{ count }} unread': '{{ count }} non letti',
	
	// Typing indicators
	'Typing...': 'Sta scrivendo...',
	'{{ user }} is typing...': '{{ user }} sta scrivendo...',
	'{{ users }} are typing...': '{{ users }} stanno scrivendo...',
	'Several people are typing...': 'Diverse persone stanno scrivendo...',
	
	// Connection states
	'Online': 'Online',
	'Last seen {{ time }}': 'Ultimo accesso {{ time }}',
	'Never': 'Mai',
	'Connection failure, reconnecting now...': 'Connessione fallita, riconnessione in corso...',
	'Reconnecting...': 'Riconnessione...',
	'Connected': 'Connesso',
	'Connecting...': 'Connessione...',
	'Offline': 'Offline',
	
	// Threads and replies
	'Thread': 'Thread',
	'View thread': 'Visualizza thread',
	'{{ count }} replies': '{{ count }} risposte',
	'1 reply': '1 risposta',
	'Reply to thread': 'Rispondi al thread',
	'Close thread': 'Chiudi thread',
	
	// Channels
	'Create Channel': 'Crea canale',
	'Edit Channel': 'Modifica canale',
	'Leave Channel': 'Lascia canale',
	'Delete Channel': 'Elimina canale',
	'Channel settings': 'Impostazioni canale',
}

/**
 * Italian locale configuration for date formatting
 */
export const italianDateConfig = {
	months: [
		'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
		'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
	],
	monthsShort: [
		'Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu',
		'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'
	],
	weekdays: [
		'Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 
		'Giovedì', 'Venerdì', 'Sabato'
	],
	weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
	weekdaysMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
	calendar: {
		lastDay: '[Ieri alle] LT',
		sameDay: 'LT',
		nextDay: '[Domani alle] LT',
		nextWeek: 'dddd [alle] LT',
		lastWeek: '[lo scorso] dddd [alle] LT',
		sameElse: 'DD/MM/YYYY'
	},
	relativeTime: {
		future: 'in %s',
		past: '%s fa',
		s: 'alcuni secondi',
		m: 'un minuto',
		mm: '%d minuti',
		h: 'un\'ora',
		hh: '%d ore',
		d: 'un giorno',
		dd: '%d giorni',
		M: 'un mese',
		MM: '%d mesi',
		y: 'un anno',
		yy: '%d anni'
	}
}
